import { type Channels, initRemoteLoginSDK } from '@eureka/shared/src/login-sdk';
import _ from 'lodash';
import { track, SELF_ENTRY_CHANNEL, TrackEventType, TrackSourceType } from '@eureka/shared/src/utils/track';

export function initLoginSdk() {
    const openLoginDialog = async (withoutClose = false, customChannels?: Channels) => {
        track({
            event_type: TrackEventType.PlgRegister,
            source_type: TrackSourceType.RegisterExposure,
            event_detail_str: JSON.stringify({
                registrationSource: SELF_ENTRY_CHANNEL,
            }),
        });

        const { openLoginDialog } = await initRemoteLoginSDK();

        await openLoginDialog({
            channels: _.assign(
                {
                    from_page: 'AIR_HOME',
                    channel_source: 'dialog_signup_eureka',
                },
                customChannels,
            ),
            withoutClose,
            onClickRegister: (method: any) => {
                try {
                    track({
                        event_type: TrackEventType.PlgRegister,
                        source_type: TrackSourceType.RegisterClick,
                        event_detail_str: JSON.stringify({
                            registrationSource: SELF_ENTRY_CHANNEL,
                            registrationMethod: method,
                        }),
                    });
                } catch (error) {
                    console.log('Failed to track registration click event:', error);
                }
            },
        }).catch((error) => {
            if(error?.type === 'close') {
                track({
                    event_type: TrackEventType.PlgRegister,
                    source_type: TrackSourceType.RegisterClose,
                    event_detail_str: JSON.stringify({
                        registrationSource: SELF_ENTRY_CHANNEL,
                    }),
                });
            }
            throw error;
        });

        if (window.__reinitializeApp) {
            await window.__reinitializeApp();
        } else {
            window.location.reload();
        }
    };

    const handleThirdPartyLoginErrors = () => {
        initRemoteLoginSDK()
            .then(({ initSDK }) => {
                initSDK();
            });
    };

    return {
        openLoginDialog,
        handleThirdPartyLoginErrors,
    };
}
